// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntextarea[data-v-e14ced00] {\n  resize: none;\n}\n", ""]);
// Exports
module.exports = exports;
